module.exports = __webpack_public_path__ + "static/btn1.a95d1243.png";